import React from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import { Icon } from "../../../components/Component";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

const DeleteTeamModal = ({ team, isOpen, toggle, refreshTable, viewType }) => {
    const axios = useAxiosPrivate();
    const queryClient = useQueryClient();

    const isChannelPartnerView = viewType === "channelPartnerTeams";
    const itemType = isChannelPartnerView ? "Channel Partner Team" : "Master Community";


    const { mutate: deleteTeam, isLoading } = useMutation(
        async (id) => {
            const res = await axios.delete(`/communityTeams/${id}`);
            return res.data;
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries("communityTeams");
                refreshTable();
                toggle();
                toast.success(`${itemType} deleted successfully.`);
            },
            onError: (error) => {
                toast.error(`Error deleting ${itemType}: ${error.message}`);
            },
        }
    );

    const handleDelete = () => {
        if (team?.id) {
            deleteTeam(team.id);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} className="modal-dialog-centered">
            <ModalBody>
                <a
                    href="#close"
                    onClick={(ev) => {
                        ev.preventDefault();
                        toggle();
                    }}
                    className="close"
                >
                    <Icon name="cross-sm"></Icon>
                </a>
                <div className="p-2">
                    <h5 className="title">Confirm Deletion</h5>
                    <p>
                        Are you sure you want to delete the {itemType}{" "}
                        <strong>{team?.teamName}</strong>? This action cannot be undone.
                    </p>
                    <div className="d-flex justify-content-end mt-4">
                        <Button color="light" className="me-2" onClick={toggle}>
                            Cancel
                        </Button>
                        <Button color="danger" onClick={handleDelete} disabled={isLoading}>
                            {isLoading ? "Deleting..." : "Delete"}
                        </Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default DeleteTeamModal;